import {ColorScheme} from '@mantine/core'

export function mode<T>(light: T, dark: T): (v: ColorScheme) => T {
  return (colorScheme: 'light' | 'dark') => (colorScheme === 'dark' ? dark : light)
}